<template>
    <vs-card v-if="listActions && listActions.length&&status_code!=='REJECTED'&&status_code!=='APPROVED'&&status_code!=='FORM_WITHOUT_APP'" class="mt-8">
        <form data-vv-scope="action">
            <span class="text-lg font-semibold block mb-4">{{
                $t("action_moderator_title")
            }}</span>
            <multiselect
                v-model="modelSelect"
                name="status"
                v-validate="'required'"
                :selectedLabel="$t('selected')"
                deselectLabel=""
                selectLabel=""
                placeholder=""
                :custom-label="(obj) => obj.name"
                track-by="uid"
                :options="listActions"
            >
            </multiselect>
            <ValidateText :error="errors" field="status" scope="action" />
            <template
                v-if="
                    modelSelect.code === 'REJECTED' ||
                    modelSelect.code === 'TO_IMPROVE'
                "
            >
                <vs-textarea
                    :label="`${$t('your_comment')} *`"
                    name="comment"
                    v-validate="'required'"
                    class="mt-4"
                    v-model="comment"
                />
                <ValidateText :error="errors" field="comment" scope="action" />

            </template>
        </form>
        <vs-button type="relief" class="mt-4" @click="saveAction">
            {{ $t("save") }}
        </vs-button>
    </vs-card>
</template>

<script>
import ValidateText from "@/pages/Home/FillingInTheApplicantsData/widgets/ValidateText";
export default {
    name: "ActionForApplicant",
    data() {
        return {
            listActions: [],
            file_upload_limitation: null,
            modelSelect: "",
            comment: "",
            files: [],
        };
    },
    props:{
        status_code:String
    },
    components: {
        ValidateText,
    },
    methods: {
        async getListActions() {
            try {
                this.$vs.loading();

                const response = (await this.$http.get("admissions/statuses/"))
                    .data;

                this.listActions = response.filter(
                    (obj) =>
                        obj.code !== "FORM_WITHOUT_APP" &&
                        obj.code !== "AWAITS_VERIFICATION"
                );
            } catch (e) {
            } finally {
                this.$vs.loading.close();
            }
        },
        async getFileUploadLimitation() {
            try {
                this.file_upload_limitation = (
                    await this.$http.get("common/settings/")
                ).data[0];
            } catch (e) {
            } finally {
            }
        },
        setFiles(response) {
            if (!this.files) this.files = [];
            if (this.files.findIndex(({ name }) => name === response[0].name)) {
                const firstFiles = this.files.filter(
                    (i) => i.firstFile || i.name !== response[0].name
                );
                const newFiles = response.map((item) => {
                    return {
                        ...item,
                        response: item,
                    };
                });
                this.files = firstFiles.concat(newFiles);
            } else {
                this.files = this.files.concat(
                    response.map((item) => {
                        return {
                            ...item,
                            response: item,
                        };
                    })
                );
            }
        },
        async removeFile({ file, done }) {
            this.files = await this.files.filter(
                (item) => item.response.uid !== file.response.uid
            );
            done();
        },
        saveAction() {
            this.$validator.validateAll("action").then(async (result) => {
                if (result) {
                    try {
                        this.$vs.loading();
                        // await this.$http.get(
                        //     `admissions/applicants/data/`,
                        //     {
                        //         params: {
                        //             profile: this.$route.query.profile,
                        //             event: 'finish_review'
                        //         }
                        //     }
                        // );

                        (
                            await this.$http.patch(
                                `admissions/applicants/${ this.$route.query.uid }/apply/`,
                                {
                                    action_type: this.modelSelect.code,
                                    reason: this.comment,
                                    files: await this.files.map(
                                        (e) => e.response.uid
                                    ),
                                }
                            )
                        ).data;

                        await this.$vs.notify({
                            text: this.$t("success_edit_status"),
                            color: "success",
                        });

                        this.$router.push({ name: "check-applications-for-moderator" });

                    } catch (e) {
                    } finally {
                        this.$vs.loading.close();
                    }
                }
            });
        },
    },
    created() {
        this.getListActions();
        this.getFileUploadLimitation();
    },
};
</script>

<style scoped lang="scss">
</style>
